import {Component, ViewChild} from "@angular/core";
import {NavigationService} from "../../navigation/NavigationService";
import {IDeviceInfo} from "../../device/IDeviceInfo";

@Component({
    styleUrls: ['./welcome.scss'],
    templateUrl: './welcome.html'
})
export class WelcomeComponent {

    public isSmartphone:boolean;

    constructor(private navigationService:NavigationService, private deviceInfo:IDeviceInfo){

    }

    ngOnInit(){
        this.isSmartphone = this.deviceInfo.IsSmartphone();
    }

    public goToGarage(){
        this.navigationService.Navigate('/garage/home')
    }

    public goToTrips(){
        this.navigationService.Navigate('/trips/home')
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/welcome/welcome.ts